import { FileMedia, IFileMedia } from "./file-media.model";
import { ITimetable, Timetable } from "./timetable.model";

export interface IAmenity {
  amenityId: string;
  neighborhoodId: string;
  fileId?: string;
  name: string;
  status: boolean;
  needAPay: boolean;
  notes?: string;
  regulationId?: string;
  capacity: number;
  guestsPerResident: number;
  bookingsPerDay: number;
  anticipations: number;
  canBeBlocked: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  image?: IFileMedia;
  regulation?: IFileMedia;
  timetables?: ITimetable[];
}

export class Amenity {
  amenityId: string;
  neighborhoodId: string;
  fileId?: string;
  name: string;
  status: boolean;
  needAPay: boolean;
  notes?: string;
  regulationId?: string;
  capacity: number;
  guestsPerResident: number;
  bookingsPerDay: number;
  anticipations: number;
  canBeBlocked: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  image?: FileMedia;
  regulation?: FileMedia;
  timetables: Timetable[];

  constructor(data: IAmenity) {
    this.amenityId = data.amenityId;
    this.neighborhoodId = data.neighborhoodId;
    this.fileId = data.fileId;
    this.name = data.name;
    this.status = data.status;
    this.needAPay = data.needAPay;
    this.notes = data.notes;
    this.regulationId = data.regulationId;
    this.capacity = data.capacity;
    this.guestsPerResident = data.guestsPerResident;
    this.bookingsPerDay = data.bookingsPerDay;
    this.anticipations = data.anticipations;
    this.canBeBlocked = data.canBeBlocked;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.image = data.image
      ? new FileMedia(data.image)
      : undefined;
    this.regulation = data.regulation
      ? new FileMedia(data.regulation)
      : undefined;
    this.timetables = data.timetables
      ? data.timetables.map(
          (timetable) => new Timetable(timetable)
        )
      : [];
  }
}
